<template>
    <div>
        <div class="recharge-nav">
            <ul class="clearfix">
                <li v-for="(item, index) in list" :key="index">
                    <router-link :to="item.path">
                        <i :class="item.meta.icon"></i>
                        <span>{{item.meta.title}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="recharge-body">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import { asyncRouterMap } from '@/router/router'
export default {
    data () {
        return {
            list: asyncRouterMap[0]['children'][1]['children']
        }
    },
    created () {

    }
}
</script>

<style lang="less">
.recharge-nav {
    overflow: hidden;
    ul {
        margin-top: -1px;
        margin-left: -1px;
        background-color: #fff;
        box-shadow: 0 1px 10px rgba(0, 21, 41, 0.05);
        li {
            width: 16.666666%;
            float: left;
            background: #fff;
            a {
                display: block;
                color: #6f738c;
                box-sizing: border-box;
                border: 1px solid #eaeef1;
                margin-right: -1px;
                margin-bottom: -1px;
                text-align: center;
                height: 70px;
                font-size: 22px;
                line-height: 70px;
            }
            .router-link-active {
                color: #fff;
                background: #FF5F4E;
                border-color: #FF5F4E;
            }
        }
    }
}
.recharge-body {
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(0, 21, 41, 0.05);
}
@media (max-width: 991px){
    .recharge-nav ul li {
        width: 20%;
    }
    .recharge-nav ul li a {
        font-size: 16px;
        height: 50px;
        line-height: 50px;
    }
}

@media (max-width: 767px){
    .recharge-nav ul li {
        width: 33.3333333%;
    }
    .recharge-nav ul li a {
        font-size: 16px;
        height: 40px;
        line-height: 40px;
    }
}
</style>
